import { legacyPlugins } from "/usr/src/app/node_modules/.pnpm/@unhead+vue@3.3.1_@oxc-project+types@0.142.0_@rspack+core@2.1.7_@swc+helpers@0.5.23__@v_44e3a8218dea74a4a6d50c99bcf35d6a/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}